#import "../fragments/lead-drip-sequences-fragment.graphql"

query GetLeadDripSequences($leadId: ID!) {
    lead(id: $leadId) {
        ...LeadDripSequencesFragment
    }
}
